<style>
.eor-title .card-body h4 {
  margin: 0 !important;
}
</style>

<template>
  <b-row class="mb-5">
    <b-col>
      <b-card :title="header" class="text-center eor-title">
        <div v-if="showMaturityDate">
          Maturity Date: {{ loan.maturity_date | date }}
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    loan: {
      type: Object,
      required: true,
    },
    showMaturityDate: {
      type: Boolean,
    },
  },
  computed: {
    header() {
      return `Loan #${this.loan.number} | ${this.loan.property.address},
      ${this.loan.property.city}, ${this.loan.property.state} ${this.loan.property.zip_code}`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_deals/actions/ActionModalWizardHeader.vue